// extracted by mini-css-extract-plugin
module.exports = {"chosenAttributes":"_30xTaKQ"};